<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> {{labels.dateRangeTitle}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="forms.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom"
                          data-vv-name="tranDateFrom" :error-messages="errors.collect('tranDateFrom')" v-validate="'required'"
                          ref="fromDate"></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="forms.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo"
                          data-vv-name="tranDateTo" :error-messages="errors.collect('tranDateTo')"
                          v-validate="'required|from_to_date:fromDate'" :min="forms.tranDateFrom"></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            :label="labels.pbPrtParam"
            v-model="forms.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
            :data-vv-as="labels.pbPrtParam"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" dark :loading="processing" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="forms.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="brnFilter" width="900px" persistent>
      <branch-filter :menu="menu" @close="doClose" @doAssign="doAssign($event)"></branch-filter>
    </v-dialog>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-information</v-icon>
        <v-toolbar-title>System Information</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div v-if="messages.length > 0" class="pb-3">
        <v-subheader>Oops something went wrong:</v-subheader>
        <ul class="showErrorMsgs">
          <li v-for="(error, index) in messages" :key="index">
          {{error.message}}
          </li>
        </ul>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      labels: {
        dateRangeTitle: 'Date Range',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        export: 'Export To',
        pbPrtParam: 'Print Runtime Parameters'
      },
      forms: {
        tranDateFrom: null,
        tranDateTo: null,
        format: 'PDF',
        pbPrtParam: true
      },
      processing: false,
      showErrorDialog: false,
      supportedFormat: [],
      menu: {},
      accmTypeList: [],
      brnFilter: false,
      panel1: [0],
      panel2: [0]
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.forms.format = value[0].value
      }
    },
    'displayErrorDialog': {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    displayErrorDialog() {
      return this.messages
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initPremSum
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.forms)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getHelpList(fieldName) {
      if (fieldName === 'branch') {
        this.brnFilter = true
      }
    },
    doAssign(data) {
      if (this.brnFilter) {
        this.forms.branch = []
        this.forms.branch = data.finalSelectedItems.toString()
      }
      this.brnFilter = false
    },
    doClose(fieldName) {
      if (fieldName === 'branch') {
        this.brnFilter = false
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
